import React, { Fragment, useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import CountrySales from "./CountrySales";
import ItemsSlider from "./ItemSlider";
import SaleChart from "./SaleChart";
import RecentSubscription from "./RecentSubscription";
import RecentPayment from "./RecentPayment";
import Payment from "./Payment";
import ExpiredSub from "./ExpireSub";
import { toast } from "react-toastify";
import { getDataWithToken } from "../../../Utils/restUtils";
import { getDashboardCounts, getIndustry } from "../../../CommonURL";
import IndustryFilter from "../../Common/Filters/IndustryFilter";
import { useSelector } from "react-redux";
import { selectRoleId } from "../../../Redux/personalDetail";

const Ecommerce = () => {
  const currentYear = new Date().getFullYear();
  const [list, setList] = useState([]);
  const [industryOptions, setIndustryOptions] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const roleId = useSelector(selectRoleId);
  useEffect(() => {
    industryData();
  }, []);
  useEffect(() => {
    getPackagesData();
  }, [selectedIndustry, selectedYear]);

  const getPackagesData = async () => {
    let url = getDashboardCounts;

    const params = [];
    if (selectedIndustry) params.push(`industry_type_id=${selectedIndustry}`);
    if (selectedYear) params.push(`year=${selectedYear}`);

    if (params.length) {
      url = `${getDashboardCounts}?${params.join("&")}`;
    }

    const data = await getDataWithToken(url);
    if (data.status === true) {
      setList(data.data);
    } else {
      toast.error(data.message);
    }
  };

  const industryData = async () => {
    const data = await getDataWithToken(getIndustry);
    if (data?.status) {
      setIndustryOptions(
        data.data.map(({ id, name }) => ({
          value: id,
          label: name,
        })),
      );
    } else {
      toast.error("Industry loading failed");
    }
  };
  const getYearOption = () => {
    const startYear = 2022;
    const currentYear = new Date().getFullYear();
    const endYear = currentYear;
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  };
  return (
    <Fragment>
      <Row className="mb-3">
        <div className="d-flex align-items-center gap-3">
          <h3 className="dashboard-title mb-0">Dashboard</h3>
          {/* <div className="btn btn-primary px-4 py-2 rounded d-flex align-items-center"> */}
          <div sm="12" md="5" lg="3" className="form-element rounded">
            <select
              className="form-select select-dashboard"
              value={selectedIndustry}
              onChange={(e) => setSelectedIndustry(e.target.value)}
              style={{
                height: "36px",
                borderRadius: "20px",
                backgroundColor: "#534686",
                color: "#fff",
                border: "1px solid #534686",
                padding: "4px 12px",
                fontSize: "14px",
                marginTop: "10px",
              }}
            >
              <option value="">Select Industry</option>

              {industryOptions.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>
          <div sm="12" md="5" lg="3" className="form-element rounded">
            <select
              className="form-select select-dashboard"
              defaultValue={currentYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
              style={{
                height: "36px",
                borderRadius: "20px",
                backgroundColor: "#534686",
                color: "#fff",
                border: "1px solid #534686",
                padding: "4px 12px",
                fontSize: "14px",
                marginTop: "10px",
              }}
            >
              {getYearOption().map((year) => {
                return (
                  <option key={year} value={year}>
                    {year}
                  </option>
                );
              })}
            </select>
          </div>

          {/* </button> */}
        </div>
      </Row>
      <Container fluid={true} className="ecommerce-page">
        <Row>
          {roleId == 1 && (
            <SaleChart
              list={list}
              industryId={selectedIndustry}
              year={selectedYear}
            />
          )}
          <RecentSubscription
            industryId={selectedIndustry}
            year={selectedYear}
          />
          <ItemsSlider
            list={list}
            industryId={selectedIndustry}
            year={selectedYear}
          />
          <CountrySales industryId={selectedIndustry} year={selectedYear}  roleId={roleId}/>
          {/* <Payment />
                    <ExpiredSub /> */}
          {/* <RecentPayment /> */}
        </Row>
        {/* <Row className="mt-4"> */}
          {/* <Payment industryId={selectedIndustry} year={selectedYear} /> */}
        {/* </Row> */}

        <Row className="mt-4">
          <ExpiredSub industryId={selectedIndustry} year={selectedYear} />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Ecommerce;
